// extracted by mini-css-extract-plugin
module.exports = {"component":"main-navigation-large-dropdown_component__VdwnK","isOpen":"main-navigation-large-dropdown_isOpen__sRHeD","isSearch":"main-navigation-large-dropdown_isSearch__C1kXb"};